var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [_vm.$style["mds-empty-state"], _vm.classObject, _vm.sizeClass],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _vm.$scopedSlots["mds-empty-state-icon"]
        ? _c(
            "div",
            { class: _vm.$style["mds-empty-state__icon"] },
            [_vm._t("mds-empty-state-icon")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: _vm.$style["mds-empty-state__title"] }, [
        _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", {
        class: _vm.$style["mds-empty-state__message"],
        domProps: { innerHTML: _vm._s(_vm.message) },
      }),
      _vm._v(" "),
      _vm.list
        ? _c(
            "ul",
            { class: _vm.$style["mds-empty-state__list"] },
            _vm._l(_vm.list, function (item, index) {
              return _c("li", { key: `mds-empty-state__list-${index}` }, [
                _vm._v("\n            " + _vm._s(item) + "\n        "),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$scopedSlots["mds-empty-state-actions"]
        ? _c(
            "div",
            { class: _vm.$style["mds-empty-state__actions"] },
            [_vm._t("mds-empty-state-actions")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }